var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"fill-height",attrs:{"no-gutters":""}},[_c('crud-factory',{attrs:{"serviceName":_vm.serviceName,"customFunctions":_vm.customFunctions,"crudDialog":_vm.crudDialog}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }